// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InitializeUserAccountRequestDto } from '../models';
/**
 * UserInitializeApi - axios parameter creator
 */
export const UserInitializeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Initialize user\'s account
         * @param {string} userId 
         * @param {InitializeUserAccountRequestDto} initializeUserAccountRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeUserAccount: async (userId: string, initializeUserAccountRequestDto: InitializeUserAccountRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('initializeUserAccount', 'userId', userId)
            // verify required parameter 'initializeUserAccountRequestDto' is not null or undefined
            assertParamExists('initializeUserAccount', 'initializeUserAccountRequestDto', initializeUserAccountRequestDto)
            const localVarPath = `/api/v1/users/{userId}/initialize`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initializeUserAccountRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserInitializeApi - functional programming interface
 */
export const UserInitializeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserInitializeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Initialize user\'s account
         * @param {string} userId 
         * @param {InitializeUserAccountRequestDto} initializeUserAccountRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initializeUserAccount(userId: string, initializeUserAccountRequestDto: InitializeUserAccountRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initializeUserAccount(userId, initializeUserAccountRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserInitializeApi.initializeUserAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserInitializeApi - factory interface
 */
export const UserInitializeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserInitializeApiFp(configuration)
    return {
        /**
         * 
         * @summary Initialize user\'s account
         * @param {string} userId 
         * @param {InitializeUserAccountRequestDto} initializeUserAccountRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeUserAccount(userId: string, initializeUserAccountRequestDto: InitializeUserAccountRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.initializeUserAccount(userId, initializeUserAccountRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserInitializeApi - interface
 */
export interface UserInitializeApiInterface {
    /**
     * 
     * @summary Initialize user\'s account
     * @param {string} userId 
     * @param {InitializeUserAccountRequestDto} initializeUserAccountRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initializeUserAccount(userId: string, initializeUserAccountRequestDto: InitializeUserAccountRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * UserInitializeApi - object-oriented interface
 */
export class UserInitializeApi extends BaseAPI implements UserInitializeApiInterface {
    /**
     * 
     * @summary Initialize user\'s account
     * @param {string} userId 
     * @param {InitializeUserAccountRequestDto} initializeUserAccountRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initializeUserAccount(userId: string, initializeUserAccountRequestDto: InitializeUserAccountRequestDto, options?: RawAxiosRequestConfig) {
        return UserInitializeApiFp(this.configuration).initializeUserAccount(userId, initializeUserAccountRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

